import { BoxProps, TextNewProps } from '@jfs/ui-new'
import { zIndex } from './DropdownConstants'

export const shadowStyle = {
  shadowColor: 'GRAY_SHADOW',
  shadowOffset: {
    width: -1,
    height: 0.5,
  },
  shadowOpacity: 0.8,
  shadowRadius: 8,
  elevation: 2,
}

const styles = {
  modal: {
    // flex: 1,
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    height: '100vh',
    width: '100%',
    zIndex: 10,
    underlayColor: 'TRANSPARENT',
    zindex: zIndex,
    // overflow: 'hidden',
  } as BoxProps,
  dropdownContainer: {
    bg: 'WHITE',
    borderWidth: 1,
    borderColor: 'ALTO_DISABLED',
    alignSelf: 'flex-start',
    ...(shadowStyle as BoxProps),
    borderRadius: 8,
  } as BoxProps,
  defaultDropdown: {
    pv: 10,
    ph: 16,
    underlayColor: 'LIGHTEST_GREY_2',
    borderBottomWidth: 1,
    borderBottomColor: 'LIGHTEST_GREY_2',
  } as BoxProps,
  defaultTextStyle: {
    color: 'BLACK',
    type: 'body14',
    fontWeight: '600',
    textAlign: 'left',
  } as TextNewProps,
  exportBox: {
    ph: 10,
    w: 110,
  } as BoxProps,
  dropdownBox: (showBorder: boolean | undefined, isIconAvailable: boolean | undefined, borderColor: any) =>
    ({
      borderWidth: showBorder ? 1 : 0,
      borderTopLeftRadius: 4,
      borderBottomLeftRadius: 4,
      borderRadius: isIconAvailable ? 0 : 4,
      borderColor: borderColor,
      height: 35,
      underlayColor: 'TRANSPARENT',
    } as BoxProps),
  overlayStyle: {
    underlayColor: 'TRANSPARENT',
    position: 'absolute',
    width: '100%',
    height: '100%',
    bg: 'TRANSPARENT',
    zIndex: zIndex,
  } as BoxProps,
  iconContainer: {
    justifyContent: 'center',
    position: 'absolute',
    left: 8,
    alignSelf: 'center',
    f: 1,
  } as BoxProps,
  dropdownIconContainer: {
    justifyContent: 'center',
    position: 'absolute',
    right: 4,
    alignSelf: 'flex-end',
    bottom: 6,
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
  label: {
    type: 'body12',
    fontWeight: '600',
    textAlign: 'center',
  } as TextNewProps,
  labelContainer: {
    justifyContent: 'center',
    width: '100%',
  } as BoxProps,
  mainView: {} as BoxProps,
}

export { styles }
